import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import SiteFooter from "@/components/SiteFooter";
import Hero from "@/components/Hero";
import Programs from "@/components/Programs";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Blog from "@/components/Blog";
import NewSteps from "@/components/NewSteps";
import Contact from "@/components/Contact";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Glow Up LEADership Academy — Leadership Coaching & DISC Training</title>
        <meta name="description" content="Leadership coaching, Maxwell DISC training, and team development for leaders, teams, and CPA firms. Grow communication, collaboration, and results." />
        <link rel="canonical" href="https://glowuplead.com/" />
        <meta property="og:title" content="Glow Up LEADership Academy — Leadership Coaching & DISC Training" />
        <meta property="og:description" content="Leadership coaching, Maxwell DISC training, and team development for leaders, teams, and CPA firms." />
        <meta property="og:url" content="https://glowuplead.com/" />
      </Helmet>
      <Navigation />
      <main className="pt-16">
        <Hero />
        <div id="programs">
          <Programs />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="testimonials">
          <Testimonials />
        </div>
        <div id="blog">
          <Blog />
        </div>
        <div id="new-steps">
          <NewSteps />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default Index;
